import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Flex,
  Box,
  Grid,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  Heading,
  Text,
  Image,
  useColorModeValue,
  FormErrorMessage,
  useToast,
  Divider,
  Progress,
} from "@chakra-ui/react";

import { appRequest } from "routes";
import CustomInput from "components/common/customInput/CustomInput";

type LoginFormValues = {
  name: string;
  password: string;
  confirmPassword: string;
  companyName: string;
  panNumber: string;
  companyGSTIN: string;
  bankAccountNo: string;
  nameasperBank: string;
  bankName: string;
  branchName: string;
  branchState: string;
  IFSCcode: string;
  shippingStreet: string;
  shippingCity: string;
  shippingState: string;
  shippingCountry: string;
  shippingPin: string;
  billStreet: string;
  billCity: string;
  billState: string;
  billCountry: string;
  billPin: string;
};

type LoginFormErrors = {
  name?: string;
  password?: string;
  confirmPassword?: string;
  companyName?: string;
  companyGSTIN?: string;
  panNumber?: string;
  bankAccountNo?: string;
  nameasperBank?: string;
  bankName?: string;
  branchName?: string;
  branchState?: string;
  IFSCcode?: string;
  shippingStreet?: string;
  shippingCity?: string;
  shippingState?: string;
  shippingCountry?: string;
  shippingPin?: string;
  billStreet?: string;
  billCity?: string;
  billState?: string;
  billCountry?: string;
  billPin?: string;
};

export default function VendorSignUpForm() {
  const toast = useToast();
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<any>(null);
  const [sendFiles, setSendFiles] = useState<any[]>([]);
  const [values, setValues] = useState<LoginFormValues>({
    name: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    companyGSTIN: "",
    panNumber: "",
    bankAccountNo: "",
    nameasperBank: "",
    bankName: "",
    branchName: "",
    branchState: "",
    IFSCcode: "",
    shippingStreet: "",
    shippingCity: "",
    shippingState: "",
    shippingCountry: "",
    shippingPin: "",
    billStreet: "",
    billCity: "",
    billState: "",
    billCountry: "",
    billPin: "",
  });
  const [errors, setErrors] = useState<LoginFormErrors>({});
  const [certificate, setCertificate] = useState({
    msme: null,
    mca: null,
    gstin: null,
    cancelledCheque: null,
  });
  const [extractedCertificate, setExtractedCertificate] = useState({
    msme: null,
    mca: null,
    gstin: null,
    cancelledCheque: null,
  });
  const validatePassword = () => {
    if (!values.password) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Password is isRequired",
      }));
    } else if (values.password.length < 6) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Password must be at least 6 characters long",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, password: undefined }));
    }
  };

  const validateConfirmPassword = () => {
    if (!values.confirmPassword) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Password is isRequired",
      }));
    } else if (values.confirmPassword.length < 6) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Password must be at least 6 characters long",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: undefined,
      }));
    }
  };

  const handleFileChange = async (event: any, type: string) => {
    const file = event.target.files && event.target.files?.[0];
    console.log(file)
    // Handle the file upload logic here
    //console.log(event.target.files)
    if (file) {
      const reader = new FileReader();
      reader.onload = async () => {
        const buffer = new Uint8Array(reader.result as ArrayBuffer);
        const updatedFile = {
          name: file.name,
          size: file.size,
          type: file.type,
          content: `[${buffer}]`,
          certificateType: type,
          url: URL.createObjectURL(file),
        }
      ;
      // setSendFiles(updatedFile);
      console.log(uploadedFile)
    //   setSendFiles((prevFiles) => [...prevFiles, updatedFile]);
    // // console.log(sendFiles);
    //     setCertificate((prevValues) => ({
    //       ...prevValues,
    //       sendFiles,
    //     }));
    //     console.log(certificate)
        analyzeCertificate(updatedFile, type);
      };
      reader.readAsArrayBuffer(file); // Read the file as data URL
    }
  };

  async function validateDocument(type: string, value: string) {}

  async function analyzeCertificate(file: any, type: string) {
    if (file?.content) {
      let input = { file: file.content, type: type };
      toast({
        title: `Verifying ${type} document.`,
        description: "Please wait for few seconds...",
        status: "info",
        duration: 10000,
        isClosable: true,
        position: "top-right",
      });
      let response: any = await appRequest("extract", "extract", input);
      setLoading(true);
      if (response) {
        if (response.status === "error") {
          toast({
            title: `Error Validating the document.`,
            description: response.message || "Something went wrong.",
            status: "error",
            duration: 9000,
            isClosable: true,
            position: "top-right",
          });

          setLoading(true);
          return new Error("Error Validating the document.");
        } else if (Object.entries(response).length > 0) {
          setExtractedCertificate((prevValues: any) => ({
            ...prevValues,
            [type]: response,
          }));

          if (type === "mca") {
            const keyvalue = response?.results?.[0]?.keyValuePair;
            setValues((prevValues) => ({
              ...prevValues,
              ["companyName"]: keyvalue?.["companyName"],
              ["panNumber"]: keyvalue?.["pan"],
              ["billStreet"]: keyvalue?.["streetAddress"],
              ["billCity"]: keyvalue?.["city"],
              ["billState"]: keyvalue?.["state"],
              ["billCountry"]: keyvalue?.["country"],
              ["billPin"]: keyvalue?.["pin"],
              ["shippingStreet"]: keyvalue?.["streetAddress"],
              ["shippingCity"]: keyvalue?.["city"],
              ["shippingState"]: keyvalue?.["state"],
              ["shippingCountry"]: keyvalue?.["country"],
              ["shippingPin"]: keyvalue?.["pin"],
              ["nameasperBank"]: keyvalue?.["companyName"],
            }));
          } else if (type === "gstin") {
            const keyvalue = response?.results?.[0]?.keyValuePair;
            setValues((prevValues) => ({
              ...prevValues,
              ["companyGSTIN"]: keyvalue?.["gstin"],
            }));
          } else if (type === "cancelledCheque") {
            const keyvalue = response?.results?.[0]?.keyValuePair;
            setValues((prevValues) => ({
              ...prevValues,
              ["bankAccountNo"]: keyvalue?.["bankAccountNo"],
              ["branchName"]: keyvalue?.["bankBranch"],
              ["branchState"]: keyvalue?.["branchState"],
              ["IFSCcode"]: keyvalue?.["bankIFSCCode"],
              ["bankName"]: keyvalue?.["bankName"],
            }));
            toast({
              title: `Extracted the data from Cancelled Cheque.`,
              description: ``,
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "top-right",
            });
          }
          if (type !== "cancelledCheque") {
            toast({
              title: `Validating the document successful.`,
              description: `${type} document validated successfully`,
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "top-right",
            });
          }
          setLoading(false);
        }
      }
    }
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    validatePassword();
    validateConfirmPassword();
    if (!errors.password && !errors.confirmPassword) {
      // Submit form
      let input: any = {
        name: values.name,
        password: values.password,
        confirmPassword: values.confirmPassword,
        companyName: values.companyName,
        companyGSTIN: values.companyGSTIN,
        panNumber: values.panNumber,
        bankDetails: {
          accountNo: values.bankAccountNo,
          name: values.nameasperBank,
          bankName: values.bankName,
          branchName: values.branchName,
          branchState: values.branchState,
          IFSCcode: values.IFSCcode,
        },
        address: {
          shipping: {
            street: values.shippingStreet,
            city: values.shippingCity,
            state: values.shippingState,
            country: values.shippingCountry,
            pin: values.shippingPin,
          },
          billing: {
            street: values.billStreet,
            city: values.billCity,
            state: values.billState,
            country: values.billCountry,
            pin: values.billPin,
          },
        },
      };
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");
        input["authToken"] = token;
        console.log(sendFiles)
        // const file = sendFiles.map((file: any) => ({
        //   name: file.name,
        //   file: `[${file.content}]`,
        //   type: file.type,
        //   certificateType: file.certificateType

        // }));
        // console.log(file);

        const response: any = await appRequest("vendor", "signup", {
          // file: { name: file.name, file: `[${file.content}]`, type: file.type },
          ...input , certificates : [...sendFiles ]
        });
        console.log(response)
        if (response) {
          // const { token } = response;
          if (response.status === "error") {
            toast({
              title: response.message,
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "top-right",
            });
          } else {
            toast({
              title: "Details updated successfully, please login",
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "top-right",
            });
            window.location.href = "/login";
          }
          // await localStorage.setItem("auth-token", token);
          // window.location.href = "/";
        }
      } catch (error: any) {
        toast({
          title: error.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top-left",
        });
      } finally {
      }
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  console.log(sendFiles)
  return (
    <Flex
      minH={"100vh"}
      // align={"center"}
      // justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Box mx="auto" minH="100vh" w="7xl" p={6}>
        <form onSubmit={handleSubmit}>
          <Box
            rounded={"lg"}
            bg={useColorModeValue("white", "gray.700")}
            boxShadow="rgb(0 0 0 / 12%) 0px 0px 11px"
            p={{ base: 5, lg: 8 }}
          >
            <Grid gridTemplateColumns={{ lg: "1fr auto" }} gap={4}>
              <Box order={{ base: 1, lg: 0 }}>
                <Heading
                  color="teal.300"
                  fontSize={{ base: "2xl", md: "4xl" }}
                  fontWeight="700"
                  mb=".8rem"
                >
                  Welcome!
                </Heading>
                <Text
                  fontSize={{ base: "sm", sm: "md" }}
                  color={useColorModeValue("gray.400", "gray.800")}
                  fontWeight="700"
                  mb={6}
                >
                  Fill the isRequired information
                  {/* Enter your email and password to sign in */}
                </Text>
              </Box>

              <Box>
                <Image src="/img/sequelstring.webp" width={320} />
              </Box>
            </Grid>
            <Stack spacing={4}>
              <Text fontWeight="600">Certificates</Text>
              <Grid
                templateColumns={{ lg: "1fr 1fr 1fr" }}
                gap={4}
                ml={{ base: "1rem", lg: "3rem" }}
              >
                <FormControl id="mcaCertificates" isRequired>
                  <FormLabel color="gray.700" fontSize="sm">
                    MCA
                  </FormLabel>
                  <Input
                    id="mcaFileInput"
                    type="file"
                    fontSize="sm"
                    accept={[
                      ".pdf",
                      ".png",
                      ".bmp",
                      ".tiff",
                      ".tif",
                      ".svg",
                      ".ico",
                      ".psd",
                      ".jpg",
                      ".jpeg",
                      ".webp",
                      ".ai",
                    ].join(",")}
                    onChange={(e) => handleFileChange(e, "mca")}
                  />
                </FormControl>
                <FormControl id="gstCertificates" isRequired>
                  <FormLabel color="gray.700" fontSize="sm">
                    GST
                  </FormLabel>
                  <Input
                    id="gstFileInput"
                    type="file"
                    fontSize="sm"
                    accept={[
                      ".pdf",
                      ".png",
                      ".bmp",
                      ".tiff",
                      ".tif",
                      ".svg",
                      ".ico",
                      ".psd",
                      ".jpg",
                      ".jpeg",
                      ".webp",
                      ".ai",
                    ].join(",")}
                    onChange={(e) => handleFileChange(e, "gstin")}
                  />
                </FormControl>
                <FormControl id="msmeCertificates" isRequired>
                  <FormLabel color="gray.700" fontSize="sm">
                    MSME
                  </FormLabel>
                  <Input
                    id="msmeFileInput"
                    type="file"
                    fontSize="sm"
                    accept={[
                      ".pdf",
                      ".png",
                      ".bmp",
                      ".tiff",
                      ".tif",
                      ".svg",
                      ".ico",
                      ".psd",
                      ".jpg",
                      ".jpeg",
                      ".webp",
                      ".ai",
                    ].join(",")}
                    onChange={(e) => handleFileChange(e, "msme")}
                  />
                </FormControl>
              </Grid>
              {loading && (
                <Progress
                  colorScheme="teal"
                  size="sm"
                  rounded={9}
                  isIndeterminate
                  mt={1}
                />
              )}
              <Divider mt="5" />
              <Grid
                templateColumns={{ lg: "1fr 1fr" }}
                gap={{ base: 6, lg: 10 }}
              >
                <Box>
                  <Text fontWeight="600">User Details:</Text>
                  <Grid gap={4} ml={{ base: "1rem", lg: "3rem" }} mt="1rem">
                    <FormControl id="userName">
                      <FormLabel color="gray.700" fontSize="sm">
                        User Name
                      </FormLabel>
                      <Input
                        type="text"
                        placeholder="User Name"
                        name="name"
                        fontSize="sm"
                        value={values.name}
                        onChange={handleChange}
                      />
                    </FormControl>

                    <FormControl id="password" isInvalid={!!errors.password}>
                      <FormLabel color="gray.700" fontSize="sm">
                        New Password
                      </FormLabel>
                      <Input
                        type="password"
                        placeholder="New password"
                        name="password"
                        fontSize="sm"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={validatePassword}
                      />
                      <FormErrorMessage>{errors.password}</FormErrorMessage>
                    </FormControl>

                    <FormControl
                      id="confirmPassword"
                      isInvalid={!!errors.confirmPassword}
                    >
                      <FormLabel color="gray.700" fontSize="sm">
                        Confirm Password
                      </FormLabel>
                      <Input
                        type="password"
                        placeholder="Confirm password"
                        name="confirmPassword"
                        fontSize="sm"
                        value={values.confirmPassword}
                        onChange={handleChange}
                        onBlur={validatePassword}
                      />
                      <FormErrorMessage>
                        {errors.confirmPassword}
                      </FormErrorMessage>
                    </FormControl>
                  </Grid>
                </Box>
                <Box>
                  <Text fontWeight="600">Company Details:</Text>
                  <Grid gap={4} ml={{ base: "1rem", lg: "3rem" }} mt="1rem">
                    <FormControl id="companyName">
                      <FormLabel color="gray.700" fontSize="sm">
                        Company Name
                      </FormLabel>
                      <Input
                        type="text"
                        placeholder="Company Name"
                        name="companyName"
                        fontSize="sm"
                        value={values.companyName}
                        onChange={handleChange}
                      />
                    </FormControl>
                    <CustomInput
                      name="panNumber"
                      value={values.panNumber}
                      onChange={handleChange}
                      label=" PAN Number"
                      placeholder="Company PAN Number"
                      type="text"
                      isRequired
                    />
                    <FormControl id="companyGSTIN">
                      <FormLabel color="gray.700" fontSize="sm">
                        GST Number
                      </FormLabel>
                      <Input
                        type="text"
                        placeholder="Company GST Number"
                        name="companyGSTIN"
                        fontSize="sm"
                        value={values.companyGSTIN}
                        onChange={handleChange}
                      />
                    </FormControl>
                  </Grid>
                </Box>
              </Grid>
              <Divider mt="5" />
              <Box>
                <Text fontWeight="600">Bank Details:</Text>
                <Grid
                  templateColumns={{ lg: "1fr 1fr" }}
                  gridColumnGap={10}
                  gridRowGap={4}
                  ml={{ base: "1rem", lg: "3rem" }}
                  mt="1rem"
                >
                  <FormControl isRequired>
                    <FormLabel color="gray.700" fontSize="sm">
                      Cancelled Cheque
                    </FormLabel>
                    <Input
                      id="fileInput"
                      type="file"
                      fontSize="sm"
                      // style={{ display: "none" }}
                      accept={[
                        ".pdf",
                        ".png",
                        ".bmp",
                        ".tiff",
                        ".tif",
                        ".svg",
                        ".ico",
                        ".psd",
                        ".jpg",
                        ".jpeg",
                        ".webp",
                        ".ai",
                      ].join(",")}
                      onChange={(e) => handleFileChange(e, "cancelledCheque")}
                    />
                  </FormControl>

                  <CustomInput
                    name="bankAccountNo"
                    value={values.bankAccountNo}
                    onChange={handleChange}
                    label="Bank Account No."
                    placeholder="Your Account No"
                    type="text"
                    isRequired
                  />
                  <CustomInput
                    name="nameasperBank"
                    value={values.nameasperBank}
                    onChange={handleChange}
                    label="Name as per Bank"
                    placeholder="Name as per Bank"
                    type="text"
                    isRequired
                  />
                  <CustomInput
                    name="bankName"
                    value={values.bankName}
                    onChange={handleChange}
                    label="Bank Name"
                    placeholder="Bank Name"
                    type="text"
                    isRequired
                  />
                  <CustomInput
                    name="branchName"
                    value={values.branchName}
                    onChange={handleChange}
                    label="Branch Name"
                    placeholder="Branch Name"
                    type="text"
                    isRequired
                  />
                  <CustomInput
                    name="branchState"
                    value={values.branchState}
                    onChange={handleChange}
                    label="Branch State"
                    placeholder="Branch State"
                    type="text"
                    isRequired
                  />
                  <CustomInput
                    name="IFSCcode"
                    value={values.IFSCcode}
                    onChange={handleChange}
                    label="IFSC Code"
                    placeholder="IFSC Code"
                    type="text"
                    isRequired
                  />
                </Grid>
              </Box>
              <Divider mt="5" />

              <Grid templateColumns={{ lg: "1fr 1fr" }} mt={4} gap={8}>
                <Box>
                  <Text fontSize="sm" fontWeight="600">
                    Shipping Address
                  </Text>
                  <Grid ml={{ base: "1rem", lg: "3rem" }} mt={4} gap={4}>
                    <CustomInput
                      name="shippingStreet"
                      value={values.shippingStreet}
                      onChange={handleChange}
                      label="Street"
                      placeholder="Street"
                      type="text"
                    />
                  </Grid>
                  <Grid
                    templateColumns={{ md: "1fr 1fr" }}
                    ml={{ base: "1rem", lg: "3rem" }}
                    mt={4}
                    gap={4}
                  >
                    <CustomInput
                      name="shippingCity"
                      value={values.shippingCity}
                      onChange={handleChange}
                      label="City"
                      placeholder="City"
                      type="text"
                    />
                    <CustomInput
                      name="shippingState"
                      value={values.shippingState}
                      onChange={handleChange}
                      label="State"
                      placeholder="State"
                      type="text"
                    />
                    <CustomInput
                      name="shippingCountry"
                      value={values.shippingCountry}
                      onChange={handleChange}
                      label="Country"
                      type="text"
                    />
                    <CustomInput
                      name="shippingPin"
                      value={values.shippingPin}
                      onChange={handleChange}
                      label="Pin"
                      placeholder="Pin"
                      type="text"
                    />
                  </Grid>
                </Box>
                <Box>
                  <Text fontSize="sm" fontWeight="600">
                    Billing Address
                  </Text>
                  <Grid ml={{ base: "1rem", lg: "3rem" }} mt={4} gap={4}>
                    <CustomInput
                      name="billStreet"
                      value={values.billStreet}
                      onChange={handleChange}
                      label="Street"
                      placeholder="Street"
                      type="text"
                    />
                  </Grid>
                  <Grid
                    templateColumns={{ md: "1fr 1fr" }}
                    ml={{ base: "1rem", lg: "3rem" }}
                    mt={4}
                    gap={4}
                  >
                    <CustomInput
                      name="billCity"
                      value={values.billCity}
                      onChange={handleChange}
                      label="City"
                      placeholder="City"
                      type="text"
                    />
                    <CustomInput
                      name="billState"
                      value={values.billState}
                      onChange={handleChange}
                      label="State"
                      placeholder="State"
                      type="text"
                    />
                    <CustomInput
                      name="billCountry"
                      value={values.billCountry}
                      onChange={handleChange}
                      label="Country"
                      placeholder="Country"
                      type="text"
                    />
                    <CustomInput
                      name="billPin"
                      value={values.billPin}
                      onChange={handleChange}
                      label="Pin"
                      placeholder="Pin"
                      type="text"
                    />
                  </Grid>
                </Box>
              </Grid>

              <Flex justifyContent={{ base: "center", lg: "end" }} mt="1rem">
                <Button
                  type="submit"
                  bg="teal.300"
                  h={"45px"}
                  w="130px"
                  fontWeight="700"
                  color="white"
                  _hover={{
                    bg: "teal.400",
                  }}
                >
                  Submit
                </Button>
              </Flex>
            </Stack>
          </Box>
        </form>
      </Box>
    </Flex>
  );
}
